export enum PAGES {
  ORDERS = 'pages/Orders',
  ORDERS_KG = 'pages/Orders/Manage',
  ORDERS_MH = 'pages/Orders/Manage',
  DASHBOARD = 'pages/Dashboard',
  ACCESS_MNT = 'pages/AccessMnt',
  CUSTOMERS = 'pages/Customers',
  PARTNERS = 'pages/Partners',
  ORDER_DEPOSITS = 'pages/Orders/Deposits',
  BUYING_DETAIL = 'pages/Orders/BuyingDetail',
  TRANSPORT_VIEW = 'pages/Orders/TransportView',

  CNImport = 'pages/Warehouse/CNImport',
  CNImportPN = 'pages/Warehouse/CNImportPN',
  VNImport = 'pages/Warehouse/VNImport',
  VNImportNext = 'pages/Warehouse/VNImportNext',
  CNSplit = 'pages/Warehouse/CNSplit',
  CNPacking = 'pages/Warehouse/CNPacking',
  CNPackingNext = 'pages/Warehouse/CNPackingNext',
  CNDocking = 'pages/Warehouse/CNDocking',
  CNDockingPN = 'pages/Warehouse/CNDockingPN',
  INVENTORY = 'pages/Warehouse/Inventory',
  ORDER_MANAGE_V2 = 'pages/Orders/Manage/v2/Manage',
  WAREHOUSE_RECEIVED_UNKNOWN_LIST = 'pages/Warehouse/ReceivedUnknownList',
  ORDER_NEED_TRANSFER_LIST = 'pages/Orders/OrderNeedTransferList',
  CONFIRM_DELIVERY = 'pages/Warehouse/ConfirmDelivery',
  SHIPMENT_PORT_LIST = 'pages/Warehouse/ShipmentPortList',
  FINANCE_PARTNER_DEBT = 'pages/Finance/PartnerDebt',
  FINANCE_CONFIGURE_PRICE = 'pages/Finance/ConfigurePrice',
  FINANCE_CUSTOMER_REVENUE = 'pages/Finance/CustomerRevenue',
}
